<template>
  <!-- 重置密码 -->
  <div class="box">
    <div class="content">
      <img class="reg-img" src="../../views/retrievePassword/assets/images/Forget password_chongzhimima.png" alt="">
      <div class="tab" v-if="HAVE_PHONE">
        <div class="tab-left" :class="[testClass==='userPone'?'tab-color1':'tab-color2']" @click="handleChangeTab('userPone')">手机</div>
        <div class="tab-right" :class="[testClass==='userEmail'?'tab-color1':'tab-color2']" @click="handleChangeTab('userEmail')">邮箱</div>
      </div>
      <el-form :model="fromData" ref="fromData" @submit.native.prevent :rules="rules">
        <!-- 手机号 -->
        <el-form-item prop="phone" v-show="testClass==='userPone'">
          <el-input @keyup.enter.native="handleTest" v-model.trim="fromData.phone" placeholder="请输入11位手机号"></el-input>
        </el-form-item>
        <!-- 邮箱号 -->
        <el-form-item prop="email" v-show="testClass==='userEmail'">
          <el-input @keyup.enter.native="handleTest" v-model.trim="fromData.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
      </el-form>
      <el-button class="regcode" @click="handleTest">验证</el-button>
    </div>
  </div>
</template>

<script>
//引入api
import { checkPhone, checkEmail, registerUserAccount, registerEmailAccount } from '@/services/loginRegister';

export default {
  name: "resetPassword",
  props: {
    // 控制显示
    stepActive: {
      type: Number,
      required: true
    },
    // 验证类别
    userTest: {
      type: String,
      required: true
    }
  },
  data() {
    // 手机号验证
    const testPone = (rule, value, callback) => {
      // const reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      let reg = /^(?:(?:\+|00)86)?1\d{10}$/;
      if (value === "") {
        callback(new Error('请输入手机号码'));
      } else if (!reg.test(value)) {
        callback(new Error('手机号码格式错误'));
      } else {
        callback();
      }
    }
    // 邮箱验证
    const testEmail = (rule, value, callback) => {
      // /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
      const reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (value === "") {
        callback(new Error('请输入邮箱'));
      } else if (!reg.test(value)) {
        callback(new Error('邮箱格式错误'));
      } else {
        callback();
      }
    }
    return {
      testClass: this.userTest, //tab切换 手机号|邮箱 默认手机号
      fromData: { //表单数据
        phone: "",
        email: ""
      },
      HAVE_PHONE: HAVE_PHONE,
      rules: {//验证规则
        phone: [
          { validator: testPone, trigger: 'blur' },
        ],
        email: [
          { validator: testEmail, trigger: 'blur' }
        ]
      },
      activeNum: this.stepActive, // 设置显示
    }
  },
  mounted() { },
  methods: {
    // 点击验证
    handleTest() {
      if (this.testClass === 'userPone') {
        this.$refs.fromData.validateField('phone', async (valid) => {
          if (valid === '') {
            let data = JSON.parse(JSON.stringify(this.fromData))
            for (const key in data) {
              if (!data[key]) {
                delete data[key]
              }
            }
            const { success, result } = await checkPhone(data.phone)
            if (success && result) {
              const params = {
                loginPhone: data.phone,
              }
              //获取验证码
              this.sendCode('pone', params, data)
            } else {
              this.$message.closeAll()
              this.$message.error('当前手机号码不存在')
            }
          }
        });
      } else if (this.testClass === 'userEmail') {
        this.$refs.fromData.validateField('email', async (valid) => {
          if (valid === '') {
            let data = JSON.parse(JSON.stringify(this.fromData))
            for (const key in data) {
              if (!data[key]) {
                delete data[key]
              }
            }
            const { success, result } = await checkEmail(data.email)
            if (success && result) {
              const params = {
                email: data.email,
              }
              //获取验证码
              this.sendCode('email', params, data)
            } else {
              this.$message.closeAll()
              this.$message.error('当前邮箱不存在')
            }
          }
        });
      }
    },
    // 发送验证码
    async sendCode(type, params, data) {
      if (type === "pone") {
        const { success } = await registerUserAccount(params)
        if (success) {
          // 向父组件传递输入的电话号码
          this.$emit('sendUserAccount', data)
          // 改变步骤条
          this.$emit('setStepActive', ++this.activeNum)
          this.resetForm()
        }
      } else if (type === "email") {
        const { success } = await registerEmailAccount(params)
        if (success) {
          // 向父组件传递输入的邮箱号码
          this.$emit('sendUserAccount', data)
          // 改变步骤条
          this.$emit('setStepActive', ++this.activeNum)
          this.resetForm()
        }
      }
    },
    // 切换tab
    handleChangeTab(type) {
      this.testClass = type
      this.$emit('setUserTest', this.testClass)
      this.resetForm()
    },
    // 清空表单数据
    resetForm() {
      this.fromData.phone = ''
      this.fromData.email = ''
      this.$refs["fromData"].clearValidate();
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  position: relative;
  width: 100%;
  height: 100%;
  background: url("../../views/retrievePassword/assets/images/Forget password_bg1.png")
    no-repeat;
  .content {
    box-sizing: border-box;
    padding: 0 75px;
    position: absolute;
    top: 127px;
    left: 0px;
    width: 460px;
    height: 400px;
    opacity: 1;
    border-radius: 10px;
    text-align: center;
    .reg-img {
      margin: 85px 0 35px 0;
      width: 151px;
      height: 40px;
    }
    .tab {
      margin-bottom: 32px;
      display: flex;
      width: 100%;
      height: 46px;
      font-size: 16px;
      font-weight: 400;
      .tab-left {
        width: 155px;
        height: 100%;
        line-height: 46px;
        text-align: center;
        opacity: 0.8;
        border-radius: 8px 0 0 8px;
        border: 1px solid #0078fc;
        cursor: pointer;
        transition: all 0.1s linear;
      }
      .tab-right {
        width: 155px;
        height: 100%;
        line-height: 46px;
        text-align: center;
        opacity: 0.8;
        border-radius: 0 8px 8px 0px;
        border: 1px solid #0078fc;
        cursor: pointer;
        transition: all 0.1s linear;
      }
      .tab-color1 {
        color: #fff;
        background-color: #0078fc;
      }
      .tab-color2 {
        color: #0078fc;
        background-color: #fff;
      }
    }
    /deep/.el-form {
      .el-form-item {
        margin-bottom: 30px;
        .el-input__inner {
          width: 310px;
          height: 46px;
          border-radius: 8px;
          &::placeholder {
            text-align: center;
            font-size: 16px;
            font-weight: 400;
            color: #999999;
            opacity: 0.8;
          }
        }
      }
    }
    .regcode {
      display: flex;
      justify-content: center;
      width: 310px;
      height: 46px;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      color: #fff;
      background: #0078fc;
      border-radius: 8px;
      &:hover {
        background: #3393fd;
        border-color: #3393fd;
      }
      &:active {
        background: #006ce3;
        border-color: #006ce3;
      }
    }
  }
}
</style>